import { configureStore } from "@reduxjs/toolkit";
import blogReducer from "./blogSlice";
import categoryReducer from "./categorySlice";
import SideBarReducer from "./SideBarSlice";
import careerReducer from "./careerSlice";
import NavBarReducer from "./NavBarSlice";
import JobReducer from "./jobslice";
import MobileNavBarReducer from "./MobileSideBar";
import ArticleReducer from "./ArticleSlice";
import VideoReducer from "./videoSlice";
import LogoReducer from "./logoSlice"

export const store = configureStore({
  reducer: {
    blog: blogReducer,
    categories: categoryReducer,
    sidebarItem: SideBarReducer,
    career: careerReducer,
    navItem: NavBarReducer,
    job: JobReducer,
    mobileNavBar: MobileNavBarReducer,
    articles: ArticleReducer,
    videos: VideoReducer,
    logo: LogoReducer
  },
});
 